import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { finalize, take } from 'rxjs/operators';
import { ModalMessageComponent } from '../../../../../shared/modais/modal-message/modal-message.component';
import { FichaService } from '../../../../ficha-veiculo.service';
import { PendenciaCaminhaoProprioImplemento } from '../../../model/veiculo';

const IMPLEMENTO_ID = '6';

@Component({
  selector: 'app-dados-caminhao-proprio-implemento',
  templateUrl:
    './dados-caminhao-proprio-implemento.component.html',
  styleUrls: [
    './dados-caminhao-proprio-implemento.component.scss',
  ],
})
export class DadosCaminhaoProprioImplementoComponent
  implements OnInit, OnDestroy {
  @Input() value: PendenciaCaminhaoProprioImplemento;
  @Output() changeForm: EventEmitter<any> = new EventEmitter();
  @Output() changeFormValid: EventEmitter<any> = new EventEmitter();

  @ViewChild('modalMessage', { static: true })
  modalMessage: ModalMessageComponent;

  @ViewChild('naoVeiculoImplemento', { static: true })
  naoVeiculoImplemento: any;
  @ViewChild('simVeiculoImplemento', { static: true })
  simVeiculoImplemento: any;

  form: FormGroup;
  bancos: any[];

  listaMarca = [];
  listaAnoModelo = [];
  listaModelo = [];

  isSelectedMarca = false;
  isSelectedAnoModelo = false;
  isSelectedModelo = false;

  isLoadingMarca = false;
  isLoadingAnoModelo = false;
  isLoadingModelo = false;

  isSelectedMarcaAfterBlur = true;
  isSelectedAnoModeloAfterBlur = true;
  isSelectedModeloAfterBlur = true;

  private subsMarca: Subscription;
  private subsModelo: Subscription;
  private subsAno: Subscription;
  private subsVeiculoImplemento: Subscription;
  private subsForm: Subscription;

  private isAlteracao = false;

  constructor(
    private formBuilder: FormBuilder,
    private fichaService: FichaService
  ) {}

  ngOnInit() {
    this.buildForm();
    this.setForm();
    this.watchForm();
    this.loadListaMarca();
  }

  ngOnDestroy() {
    if (this.subsMarca) {
      this.subsMarca.unsubscribe();
    }
    if (this.subsModelo) {
      this.subsModelo.unsubscribe();
    }
    if (this.subsAno) {
      this.subsAno.unsubscribe();
    }
    if (this.subsVeiculoImplemento) {
      this.subsVeiculoImplemento.unsubscribe();
    }
    if (this.subsForm) {
      this.subsForm.unsubscribe();
    }
  }

  private setForm(): void {
    if (this.value) {
      this.form.patchValue(this.value);
      if (
        this.value.veiculoImplemento ||
        (!this.value.veiculoImplemento &&
          this.value.veiculoImplemento !== undefined &&
          this.value.veiculoImplemento !== null)
      ) {
        this.simVeiculoImplemento.value = this.value.veiculoImplemento;
        this.naoVeiculoImplemento.value = !this.value.veiculoImplemento;
      }
      if (this.value.veiculoImplemento) {
        this.isAlteracao = true;
        this.onChangeMarca(null);
        this.onChangeAnoModelo(null);
        this.onChangeModelo(null);
      }
    }
  }

  private watchForm(): void {
    this.subsVeiculoImplemento = this.form
      .get('veiculoImplemento')
      .valueChanges.subscribe(() => {
        this.form.get('veiculoMarca').setValue('');
        this.form.get('veiculoAno').setValue('');
        this.form.get('veiculoModelo').setValue('');
      });

    this.subsForm = this.form.valueChanges.subscribe(() => {
      this.changeForm.emit(this.form.value);
      this.changeFormValid.emit(this.formValid);
    });
  }

  private buildForm(): void {
    this.form = this.formBuilder.group({
      veiculoImplemento: null,
      veiculoMarca: '',
      veiculoAno: ({ value: '', disabled: !this.isSelectedMarca }),
      veiculoModelo: ({ value: '', disabled: !this.isSelectedAnoModelo }),
    });
  }

  public setVeiculoImplemento(event) {
    const component = <HTMLInputElement>event.target;

    if (component.id === 'naoVeiculoImplemento') {
      this.simVeiculoImplemento.value = !component.checked;
      this.form.get('veiculoImplemento').setValue(!component.checked);
      return;
    }

    this.naoVeiculoImplemento.value = !component.checked;
    this.form.get('veiculoImplemento').setValue(component.checked);
  }

  public get veiculoImplemento(): boolean {
    return this.form.get('veiculoImplemento').value;
  }

  public get showDadosPreencher(): boolean {
    return this.veiculoImplemento;
  }

  public get formValid(): boolean {
    const {
      veiculoImplemento,
      veiculoMarca,
      veiculoAno,
      veiculoModelo,
    } = this.form.getRawValue();

    if (veiculoImplemento) {
      return !!(veiculoMarca && veiculoAno && veiculoModelo);
    }

    return veiculoImplemento === false;
  }

  public get veiculoMarca(): string {
    return (
      this.form &&
      this.form.get('veiculoMarca') &&
      this.form.get('veiculoMarca').value &&
      this.form.get('veiculoMarca').value.id
    );
  }

  public get veiculoAno(): string {
    return (
      this.form &&
      this.form.get('veiculoAno') &&
      this.form.get('veiculoAno').value
    );
  }

  public get veiculoModelo(): string {
    return (
      this.form &&
      this.form.get('veiculoModelo') &&
      this.form.get('veiculoModelo').value &&
      this.form.get('veiculoModelo').value.id
    );
  }

  clearList(lista: string[]) {
    if (!this.isAlteracao && lista && lista.length) {
      lista.forEach((item) => {
        switch (item) {
          case 'Marca': {
            this.listaMarca = [];
            this.isSelectedMarca = false;
            this.form.get('veiculoMarca').setValue('');
            this.onSelectedMarcaChange();
            break;
          }
          case 'AnoModelo': {
            this.listaAnoModelo = [];
            this.isSelectedAnoModelo = false;
            this.form.get('veiculoAno').setValue('');
            this.onSelectedAnoModeloChange();
            break;
          }
          case 'Modelo': {
            this.listaModelo = [];
            this.isSelectedModelo = false;
            this.form.get('veiculoModelo').setValue('');
            break;
          }
        }
      });
      this.isSelectedMarcaAfterBlur = true;
      this.isSelectedAnoModeloAfterBlur = true;
      this.isSelectedModeloAfterBlur = true;
    }
  }

  loadListaMarca() {
    this.clearList(['Marca', 'AnoModelo', 'Modelo']);
    this.isLoadingMarca = true;
    this.subsMarca = this.fichaService
      .getMarcaPorTipo(IMPLEMENTO_ID)
      .pipe(
        take(1),
        finalize(() => {
          this.isLoadingMarca = false;
        })
      )
      .subscribe((res) => {
        this.listaMarca = res.marcas;
        if (this.isAlteracao && this.value && this.value.veiculoMarca) {
          const veiculoMarca = this.listaMarca.find(
            (f) => Number(f.id) === Number(this.value.veiculoMarca.id)
          );
          this.form.get('veiculoMarca').setValue(veiculoMarca);
        }
        this.resetAlteracao();
      });
  }

  loadListaAnoModelo() {
    this.clearList(['AnoModelo', 'Modelo']);

    this.isLoadingAnoModelo = true;
    this.subsAno = this.fichaService
      .getAnoModeloPorMarca(IMPLEMENTO_ID, this.veiculoMarca)
      .pipe(
        take(1),
        finalize(() => {
          this.isLoadingAnoModelo = false;
        })
      )
      .subscribe(
        (res) => this.handleListaAnoModelo(res.anosModelo),
        (error) => {
          this.modalMessage.show(
            'Não há ano de implemento para as características selecionadas.'
          );
        }
      );
  }

  private handleListaAnoModelo(anos) {
    this.listaAnoModelo = anos;
    this.resetAlteracao();
  }

  resetAlteracao() {
    if (
      !this.isLoadingMarca &&
      !this.isLoadingAnoModelo &&
      !this.isLoadingModelo
    ) {
      this.isAlteracao = false;
    }
  }

  loadListaModelo() {
    this.clearList(['Modelo']);
    this.isLoadingModelo = true;
    this.subsModelo = this.fichaService
      .getModeloPorMarcaAno(IMPLEMENTO_ID, this.veiculoMarca, this.veiculoAno)
      .pipe(
        take(1),
        finalize(() => {
          this.isLoadingModelo = false;
        })
      )
      .subscribe(
        (res) => {
          this.listaModelo = res.modelos;
          if (this.isAlteracao && this.value && this.value.veiculoModelo) {
            const veiculoModelo = this.listaModelo.find(
              (f) => Number(f.id) === Number(this.value.veiculoModelo.id)
            );
            this.form.get('veiculoModelo').setValue(veiculoModelo);
          }
          this.resetAlteracao();
        },
        () =>
          this.modalMessage.show(
            ' Não há modelo de implemento para as características selecionadas.'
          )
      );
  }

  onChangeMarca(event) {
    this.isSelectedMarca = true;
    this.onSelectedMarcaChange();
    this.loadListaAnoModelo();
  }

  onChangeAnoModelo(event) {
    this.isSelectedAnoModelo = true;
    this.onSelectedAnoModeloChange();
    this.loadListaModelo();
  }

  onChangeModelo(event) {
    this.isSelectedModelo = true;
    // this.loadListaModelo();
  }

  onBlurMarca(event) {
    this.isSelectedMarcaAfterBlur = event.target.selectedIndex > 0;
  }

  onBlurAnoModelo(event) {
    this.isSelectedAnoModeloAfterBlur = event.target.selectedIndex > 0;
  }

  onBlurModelo(event) {
    this.isSelectedModeloAfterBlur = event.target.selectedIndex > 0;
  }

  onSelectedMarcaChange() {
    if (this.isSelectedMarca) {
      this.form.get('veiculoAno')?.enable();
    } else {
      this.form.get('veiculoAno')?.disable();
    }
  }

  onSelectedAnoModeloChange() {
    if (this.isSelectedAnoModelo) {
      this.form.get('veiculoModelo')?.enable();
    } else {
      this.form.get('veiculoModelo')?.disable();
    }
  }
}
